module.exports = __webpack_public_path__ + "img/seo_thumbnail-400x300.03929e98.jpg";